import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import LanguageSelectStore from '@src/business-components/language-select/store';

const styles = require('./index.less');
/**
 * 语言选择器
 * @param store {LanguageSelectStore}
 * @param buttonDisplay
 * @returns {JSX.Element}
 * @constructor
 * @example
 * footer使用: <LanguageSelect buttonDisplay={'footer'} />
 * header使用: <LanguageSelect buttonDisplay={'nav'} />
 */
const LanguageSelect = ({ store, buttonDisplay }) => {
  store.use();

  const styleName = {
    nav: styles.language_nav_container,
    footer: styles.language_footer_container
  };
  const renderBtn = () => {
    if (buttonDisplay === 'nav') {
      return (
        <div className={cx(styles.btn_display_nav)} onClick={store.onLanguageBtnClick}>
          <div className={cx(styles.btn_background_nav, store.isOpen && styles.innerExpanded_nav)} />
          <div className={styles.pc_icon_language_nav} />
        </div>
      );
    } else if (buttonDisplay === 'footer') {
      return (
        <div className={cx(styles.btn_display_footer, store.isOpen && styles.innerExpanded_footer)} onClick={store.onLanguageBtnClick}>
          <div className={styles.pc_icon_language_footer} />
          <div className={styles.language_switch_text}>{store.languageSelected}</div>
          <div className={styles.pc_icon_flyout} />
        </div>
      );
    }
  };
  const renderExpand = () => {
    if (buttonDisplay === 'nav') {
      return (
        <div className={cx(styles.expand_display_nav, store.isOpen && styles.show)}>
          {store.languageList.map((item, index) => {
            return (
              <div
                key={index}
                className={cx(styles.language_tag_nav, store.languageSelected === item.language && styles.nav_language_selected)}
                onClick={() => store.onLanguageSelected(index)}
              >
                <div className={styles.language_text_nav}>{item.language}</div>
                <div className={styles.language_tick} />
              </div>
            );
          })}
        </div>
      );
    } else if (buttonDisplay === 'footer') {
      return (
        <div className={cx(styles.expand_display_footer, store.isOpen && styles.show)}>
          {store.languageList.map((item, index) => {
            return (
              <div
                key={index}
                className={cx(styles.language_tag_bottom, store.languageSelected === item.language && styles.languageSelected)}
                onClick={() => store.onLanguageSelected(index)}
              >
                <div className={styles.language_text}>{item.language}</div>
                <div className={styles.language_tick} />
              </div>
            );
          })}
        </div>
      );
    }
  };
  return (
    <div className={styleName[buttonDisplay]} id={'languageContainer'}>
      {renderBtn()}
      {renderExpand()}
    </div>
  );
};

export default wrapStore(LanguageSelect, LanguageSelectStore);
